import { Avatar, ProfileItem } from '@intigral/shared';
import { getProfileAvatar, selectProfileHandler } from '../../utils/headerUtils';
import { __ } from '../../../../translations';
import { iRenderProfileItemProps } from '../../types/iHeaderMenu';

export const RenderProfileItem: React.FC<iRenderProfileItemProps> = ({
    index,
    profile,
    selectedProfile,
    avatarData,
    setClickedProfile,
}) => {
    // const profileIsLocked = h.isAccountRetrievalFeatureEnabled() ? selectedProfile?.parentalLockOn : false;
    if (profile.profileName !== selectedProfile.profileName) {
        // If your profile is (Locked OR is a Kid profile) list only kids profiles, otherwise list all profiles.
        const conditionToShowThisProfile = selectedProfile.kidsMode ? profile.kidsMode : true;
        if (conditionToShowThisProfile) {
            // hide non-kids profile if you are in kids profile mode
            return (
                <>
                    <ProfileItem
                        avatar={
                            <Avatar
                                image={getProfileAvatar(profile, avatarData)}
                                name={profile.profileName}
                                currentRestriction={__(profile?.newParentalControl || profile?.parentalControl)}
                                variant="inline"
                            />
                        }
                        compact
                        data-test-id={`profile-menu-item-${profile.profileName.toLowerCase().replace(/\s+/g, '-')}`}
                        onClick={(e) => selectProfileHandler(e, profile, setClickedProfile)}
                    >
                        {profile.passwordProtected && <span className="icon-Lock" />}
                    </ProfileItem>
                </>
            );
        }
    }
};
